
import {spApi} from './sp'

export const spReviewLikeApi = spApi.injectEndpoints({
  endpoints: (builder) => ({
    
    spReviewLike: builder.mutation({
      invalidatesTags: ['spreviews'],
      query: ({payload}) => ({
        url: '/likedislikereview',
        method: 'POST',
        body: payload,
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useSpReviewLikeMutation } = spReviewLikeApi